type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  back: TypeActionNameWithTo
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  print: TypeActionNameWithTo
}

const nameEntity = 'Contract'
const nameSource = 'userContracts'
const namePageTitle = 'Contratos do usuário'

const nameActions: PortletTitleCrudType = {
  back: {
    name: 'Retornar',
    to: '#!',
    icon: 'fa fa-arrow-left'
  },
  create: {
    name: 'Adicionar',
    to: '/commercial/userContracts/students/:id/create',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/userContracts/view/:id',
    icon: 'fa fa-list'
  },
  print: {
    name: 'Imprimir',
    to: '/commercial/userContracts/view/:id',
    icon: 'fa fa-print'
  }
}

export { nameEntity, nameSource, namePageTitle, nameActions }
